import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { AppData } from "../../helpers/app-data";
import { BaseServiceService } from "../../services/base-service.service";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Usuario } from "../usuarios/usuarios.component";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus
} from '@azure/msal-browser';
import { filter, Subject, Subscription, takeUntil } from "rxjs";
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';


declare var fabric: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.css",
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  dialogComponent: any;
  loginForm?: FormGroup;
  //loginObj: login;
  invalid = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  private subscriptions: Subscription = new Subscription();
  ViewSSOLoginButton: any;

  @ViewChild("dialogContainer") dialogContainer!: ElementRef;
  @ViewChild("button") button!: ElementRef;
  @ViewChild("label") label!: ElementRef;
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  constructor(
    private router: Router,
    private authService: AuthService,
    private baseService: BaseServiceService,
    private _formBuilder: FormBuilder,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  ) {
    //this.loginObj = new login();
    this.formInit();
  }


  async ngOnInit(): Promise<void> {
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
    // habilitar si se quiere chequear cuenta existente y mantener sesión activa
    // this.checkExistingAccount();
    
    API_TOKEN ? sessionStorage.removeItem(AppData.localStorageToken) : {};
    this.subscriptions.add(
      this.loginForm?.get("UserName")?.valueChanges.subscribe(() => {
        this.loginForm?.get("hasErrorUserName")?.setValue(false);
      })
    );

    // Escuchar cambios en el campo Password
    this.subscriptions.add(
      this.loginForm?.get("Password")?.valueChanges.subscribe(() => {
        this.loginForm?.get("hasErrorPassword")?.setValue(false);
      })
    );

    // Escuchar cambios en el campo de estado de usuario inactivo
    this.subscriptions.add(
      this.loginForm?.get("UserName")?.valueChanges.subscribe(() => {
        this.loginForm?.get("hasErrorInvalid")?.setValue(false);
      })
    );
  }
  async ngAfterViewInit(): Promise<void> {
    
    this.ViewSSOLoginButton = AppData.ViewSSOLoginButton;

    await this.msalService.instance.initialize(); 
    this.handleMsalRedirect();
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  abrirDialogoDeLogin(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const dialog =
        this.dialogContainer.nativeElement.querySelector(".ms-Dialog");
      if (!dialog) {
        reject(new Error("Dialog element not found within dialog container."));
        return;
      }

      this.dialogComponent = new fabric["Dialog"](dialog);
      var SpinnerElements = document.querySelectorAll(".ms-Spinner");
      for (var i = 0; i < SpinnerElements.length; i++) {
        new fabric["Spinner"](SpinnerElements[i]);
      }
      this.dialogComponent.open();

      resolve();
    });
  }

  async onLogin() {
    this.botonProcesando = true;
    try {
      const res = await this.authService.login(
        this.loginForm?.get("UserName")?.value,
        this.loginForm?.get("Password")?.value
      );
      if (res.Ok) {
        this.authService.setAuthentication(true); // Establece el estado de autenticación como verdadero
        sessionStorage.setItem(AppData.localStorageToken, res.Data.JWToken); // Se almacena el token en local storage
        this.router.navigateByUrl("/home");
        this.botonProcesando = false;
        this.baseService.setUsername(res.Data.Name);
        this.baseService.setUserRol(res.Data.RolName);
        this.baseService.setUserPermissions(res.Data.OpcionesMenu);
        this.baseService.setUserValidationType(res.Data.userValidationType);

      } else {
        this.botonProcesando = false;

        // Limpiar errores previos
        this.clearLoginErrors();

        // Mapeo de errores
        this.handleLoginErrors(res.Error);
      }
    } catch (er: any) {
      this.botonProcesando = false;
      this.modalNotifyComponent.show(
        "Error al iniciar sesión",
        er.error.Error,
        ModalNotifyTypes.Warning,
        false
      );
    }
  }

  private clearLoginErrors() {
    this.loginForm?.get("hasErrorUserName")?.setValue(false);
    this.loginForm?.get("hasErrorPassword")?.setValue(false);
    this.loginForm?.get("hasErrorInvalid")?.setValue(false);
  }

  private handleLoginErrors(errorMessage: string) {
    const errorMapping = {
      "No existe usuario": {
        errorKey: "hasErrorPassword",
        controlKey: "UserName",
      },
      "Clave invalida": {
        errorKey: "hasErrorPassword",
        controlKey: "Password",
      },
      "Usuario se encuentra inactivo": {
        errorKey: "hasErrorInvalid",
        controlKey: "UserName",
      },
    };

    for (const [key, { errorKey, controlKey }] of Object.entries(
      errorMapping
    )) {
      if (errorMessage.includes(key)) {
        this.loginForm?.get(errorKey)?.setValue(true);
        this.loginForm?.get(controlKey)?.markAsTouched();
        break; // Salir del ciclo una vez que se encuentre un error
      }
    }
  }

  formInit() {
    this.loginForm = this._formBuilder.group({
      UserName: new FormControl("", [
        Validators.required,
        Validators.email,
        Validators.maxLength(100),
      ]),
      Password: new FormControl("", [Validators.maxLength(100)]),
      hasErrorPassword: new FormControl(false),
      hasErrorInvalid: new FormControl(false),
    });
  }

  async loginWithSSO() {
    try {
      this.botonProcesando = true;
      await this.msalService.instance.initialize();
      
      await this.msalService.loginRedirect({
        prompt: 'select_account',
        scopes: [AppData.ScopeSSO]
      });
    } catch (error) {
      console.error('Error en SSO login:', error);
      this.botonProcesando = false;
      this.modalNotifyComponent.show(
        "Error al iniciar sesión con SSO",
        "No se pudo iniciar sesión con Microsoft",
        ModalNotifyTypes.Warning,
        false
      );
    }
  }

  private handleMsalRedirect() {
    // Escuchar eventos de éxito de login
    this.subscriptions.add(
      this.msalBroadcastService.msalSubject$
        .pipe(
          filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
        )
        .subscribe((result: EventMessage) => {
          console.log('LOGIN_SUCCESS event received:', result);
          const payload = result.payload as any;
          if (payload?.account) {
            const email = payload.account.username;
            console.log('Usuario autenticado con SSO:', email);
            this.onLoginSSO(email);
          }
        })
    );

    // También escuchar cambios en el estado de interacción
    this.subscriptions.add(
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None)
        )
        .subscribe(() => {
          const accounts = this.msalService.instance.getAllAccounts();
          if (accounts.length > 0) {
            console.log('Cuenta encontrada después de redirect:', accounts[0].username);
            // Verificar si no hemos procesado este login aún
            const hasToken = sessionStorage.getItem(AppData.localStorageToken);
            if (!hasToken) {
              this.onLoginSSO(accounts[0].username);
            }
          }
        })
    );
  }

  private checkExistingAccount() {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      const hasToken = sessionStorage.getItem(AppData.localStorageToken);
      if (accounts.length > 0 && hasToken) {
        this.onLoginSSO(accounts[0].username);
      }      
    }
  }

  async onLoginSSO(email: string) {
    if (this.botonProcesando) return; // Evitar múltiples llamadas
    this.botonProcesando = true;
    try {
      
      const accounts = this.msalService.instance.getAllAccounts();
      const response = await this.msalService.instance.acquireTokenSilent({
        account: accounts[0],
        scopes: [AppData.ScopeSSO]
      });
      const AccessTokenSSO = response.accessToken;
      const res = await this.authService.login(email, undefined, AccessTokenSSO);
      if (res.Ok) {
        this.authService.setAuthentication(true);
        sessionStorage.setItem(AppData.localStorageToken, res.Data.JWToken);
        this.baseService.setUsername(res.Data.Name);
        this.baseService.setUserRol(res.Data.RolName);
        this.baseService.setUserPermissions(res.Data.OpcionesMenu);
        this.baseService.setUserValidationType(res.Data.userValidationType);
        
        this.router.navigateByUrl('/home');
      } else {
        this.botonProcesando = false;
        this.modalNotifyComponent.show(
          "Error al iniciar sesión",
          res.Error || "No se pudo autenticar con el servidor",
          ModalNotifyTypes.Warning,
          false
        );
      }
    } catch (error: any) {
      this.botonProcesando = false;
      console.error('Error en onLoginSSO:', error);
      this.modalNotifyComponent.show(
        "Error al iniciar sesión",
        error?.error?.Error || "Error al procesar la autenticación SSO",
        ModalNotifyTypes.Warning,
        false
      );
    }
  }
}

